var FavoritesService = {
  _key: 'odva.marketplace.favorites',

  getAll: function() {
    try {
      return JSON.parse(localStorage.getItem(this._key)) || [];
    } catch(e) { return []; }
  },

  isFavorited: function(productId) {
    return this.getAll().indexOf(productId) !== -1;
  },

  toggle: function(productId) {
    var favs = this.getAll();
    var idx = favs.indexOf(productId);
    if (idx === -1) {
      favs.push(productId);
    } else {
      favs.splice(idx, 1);
    }
    localStorage.setItem(this._key, JSON.stringify(favs));
    return favs;
  }
};

export default FavoritesService;
